import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import FormSkeleton from 'components/FormSkeleton';
import NotFound from 'components/NotFound';
import PageWithSidebar from 'components/PageWithSidebar';
import LabelSidebar from 'components/LabelSidebar';
import LabelEditForm from 'components/LabelEditForm';

import { withData } from 'lib';
import { SettingsLabelEditPageQuery } from '__generated__/SettingsLabelEditPageQuery.graphql';

const query = graphql`
  query SettingsLabelEditPageQuery($id: ID!) {
    label(id: $id) {
      name

      ...LabelEditForm_label
      ...LabelSidebar_label
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsLabelEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { link: '/settings/labels', name: 'Etiketės' },
];

const SettingsLabelEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { label } = usePreloadedQuery<SettingsLabelEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!label) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<LabelSidebar label={label} />}
      breadcrumbs={[
        ...breadcrumbs,
        {
          name: label.name,
        },
      ]}>
      <LabelEditForm label={label} />
    </PageWithSidebar>
  );
};

export default withData<SettingsLabelEditPageQuery, RouteParams>({
  query,

  loading: (
    <EntityEditPageSkeleton breadcrumbs={breadcrumbs}>
      <FormSkeleton sections={1} />
    </EntityEditPageSkeleton>
  ),

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(SettingsLabelEditPage);
